export default __webpack_public_path__ + "static/Timelinev2-b9b9077bf04cd25a580d1d35eac7686c.png";